export default "__VITE_ASSET__4312d7b9__"